import React, { FC } from 'react'
import { Typography } from 'out-game/components'
import { ReactComponent as ChatIcon } from 'out-game/images/icons/chat-icon.svg'
import cn from 'classnames'
import ButtonRestyled from '../../components/ButtonRestyled'
import { useTranslationStrict } from 'out-game/hooks'

type ButtonProps = {
  isChatOpened: boolean
  setIsChatOpened: (value: boolean) => void
  setUnreadMessages: (value: boolean) => void
  isUnreadMessages: boolean
}

const Button: FC<ButtonProps> = ({
  isChatOpened,
  setIsChatOpened,
  setUnreadMessages,
  isUnreadMessages
}) => {
  const { t } = useTranslationStrict('menu')
  
  if (isChatOpened) {
    return null
  }

  return (
    <ButtonRestyled
      variant="grad-blue"
      glowing
      className={cn(
        'overlay-button',
        'overlay-button_open-chat',
        isUnreadMessages && 'overlay-button_unread'
      )}
      onClick={() => {
        setIsChatOpened(!isChatOpened)
        setUnreadMessages(false)
      }}
    >
      <Typography
        className="overlay-button__text"
        size={22}
        lineHeight={0}
        color="Emphasized"
      >
        {t('floodroom')}
      </Typography>
      <ChatIcon className="overlay-button__icon" />
    </ButtonRestyled>
  )
}

export default Button
